import { render, staticRenderFns } from "./DelayedPackingLists.vue?vue&type=template&id=3f96dfef&scoped=true&"
import script from "./DelayedPackingLists.vue?vue&type=script&lang=js&"
export * from "./DelayedPackingLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f96dfef",
  null
  
)

export default component.exports